import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import {
  getExcel,
  getSeparates,
  searchSeparates,
  uploadExcel,
} from "../../api/Separates";
import LoadingPage from "../Loading/loading";
import { Cookies } from "react-cookie";
import { IoMdSend } from "react-icons/io";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SeparatesComponent = () => {
  const cookie = new Cookies();
  const navigate = useNavigate();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [loading, setLoading] = useState(true);
  const [isClick, setIsClick] = useState(false);
  const [separates, setSeparates] = useState(null);
  const [pageCount, setPageCount] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    cookie.get("separate_page") || 1,
  );
  const [searchValue, setSearchValue] = useState("");

  const separatesGet = () => {
    setSeparates(null);
    if (searchValue && searchValue !== "") {
      searchSeparates(currentPage, searchValue).then((result) => {
        setSeparates(result.data.separates);
        setLoading(false);
        setPageCount(result.data.pageCount);
      });
    } else {
      getSeparates(currentPage).then((result) => {
        setSeparates(result.data.separates);
        setLoading(false);
        setPageCount(result.data.pageCount);
      });
    }
  };

  useEffect(() => {
    setSeparates(null);
    separatesGet();
  }, [currentPage]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("separate_page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNext = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
      cookie.set("separate_page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePageClick(1);
    separatesGet();
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (pageCount <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, pageCount - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < pageCount - 1) {
          pages.push("...");
        }
        pages.push(pageCount);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const uploadFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setIsClick(true);
      setSeparates(null);
      const formBack = new FormData();
      formBack.append("excel", e.target.files[0]);
      uploadExcel(formBack).then((result) => {
        separatesGet();
        setIsClick(false);
        toast.success("Successfully Uploaded", {
          position: "top-right",
        });
      });
    }
  };

  return (
    <>
      {separates === null || loading ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="search-container">
            {isSuper && (
              <>
                {isClick ? (
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <div className="spinner"></div>
                  </div>
                ) : (
                  <button
                    className="paginationButton"
                    onClick={() => {
                      setIsClick(true);
                      getExcel().then((value) => {
                        setIsClick(false);
                      });
                    }}
                  >
                    Download
                  </button>
                )}
              </>
            )}

            {!isClick && (
              <>
                {isSuper && (
                  <input
                    type="file"
                    id="file"
                    name="file"
                    onChange={(e) => uploadFile(e)}
                    accept=".xlsx"
                    className="paginationButton"
                  />
                )}
              </>
            )}
            <form onSubmit={handleSubmit}>
              <div className="search-input-wrapper">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Name or Phone number"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="search-input"
                />
                <button
                  type="submit"
                  className="password-toggle"
                  aria-label="Show password"
                >
                  <IoMdSend />
                </button>
              </div>
            </form>
          </div>
          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "10px",
            }}
          >
            {renderPageNumbers()}
            <button
              onClick={handleNext}
              disabled={currentPage === pageCount}
              className="paginationButton"
            >
              Next
            </button>
          </div>

          <div className="card-cards">
            {separates?.length === 0 ? (
              <div>Not found</div>
            ) : (
              <>
                {separates?.map((separate) => (
                  <div
                    key={separate._id}
                    className={`card-card ${separate.ban ? "banned" : ""}`}
                  >
                    <div className="card-info">
                      <div>
                        <p className="line">
                          <span className="label">separate name:</span>{" "}
                          {separate.project.name}
                        </p>
                        <p className="line">
                          <span className="label">Dev Name:</span>{" "}
                          {separate.company.name}
                        </p>
                      </div>
                    </div>
                    <div className="card-actions">
                      <button
                        onClick={() => {
                          navigate(`/separate/${separate._id}`);
                        }}
                        className="action-btn accept-btn"
                      >
                        View
                      </button>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default SeparatesComponent;
